import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";

/**
 * ダウンロードするURLを取得
 */
export default async function downloadJoyfulSampleCsv() {
  console.log(`downloadJoyfulSampleCsv`);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/csv/download`;
  const res = await http.get(url);
  console.log(res);
  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}

  downloadFromUrl(res.data.url, 'ジョイフルサンプル');

  return res.data;
}